<template>
    <div
        class="min-h-[70vh] flex flex-col items-center justify-center relative py-[150px] tablet:landscape:py-[50px] desktop:landscape:py-[100px] laptop:py-[100px] largeDesktop:py-[140px] largeDesktop:pb-[130px]">
        <div
            class="relative text-center rounded-[10px] shadow-[0px_0px_10px_0px_#0000001A] border-[10px] border-[#fff] bg-[#fff] mobile:max-w-[400px] tablet:max-w-[500px] laptop:max-w-[400px] largeDesktop:max-w-[500px]">
            <div
                class="animate-float absolute tablet:landscape:-top-[120px] desktop:landscape:-top-[110px] mobile:-top-[130px] tablet:-top-[160px] laptop:-top-[110px] largeDesktop:-top-[180px] left-0 right-0 ">
                <img src="../../../assets/images/myHappyHomeFamilyImg.png" alt="Family Image"
                    class="mobile:w-[230px] tablet:w-[60%] tablet:landscape:w-[45%] desktop:landscape:w-[50%] laptop:w-[50%] largeDesktop:w-[70%] mx-auto transition duration-300 hover:animate-scaleUp">
            </div>
            <div
                class="relative z-10 py-[10px] tablet:py-[20px] laptop:py-[10px] px-[20px] tablet:px-[40px] rounded-[10px]">
                <h2
                    class="pb-[10px] laptop:pb-0 largeDesktop:pb-[10px] laptop:mt-0 laptop:mb-0 largeDesktop:my-[15px] font-days text-[30px] tablet:text-[40px] laptop:text-[22px] largeDesktop:text-[40px] font-semibold text-customBlue-100">
                    Thank You</h2>
                <p
                    class="mb-[5px] laptop:mt-[10px] laptop:mb-[5px] largeDesktop:my-[15px] font-poppins text-[18px] tablet:text-[20px] laptop:text-[16px] largeDesktop:text-[20px] font-semibold text-customYellow-100">
                    Order No: {{
                        $route?.query?.order_id ?? '-' }}</p>
                <h6
                    class="m-0 font-poppins text-[18px] tablet:text-[25px] laptop:text-[17px] largeDesktop:text-[25px] font-normal text-[#333]">
                    Congratulations!</h6>
                <p class="m-0 font-poppins text-[16px] laptop:text-[14px] font-normal text-[#333]">You are now protected
                    with a protection
                    plan by <span class="text-[#F5B134]">My<span class="text-[#2459A8]">HappyHome.</span></span> </p>
                <button @click="onContinueClicked()"
                    class="CustomYellowBtn uppercase mt-[15px] laptop:mt-[10px] largeDesktop:mt-[20px] px-[22px] py-[5px] largeDesktop:py-[10px] rounded-full font-poppins text-[14px] font-semibold border-[1px] ">Continue</button>
            </div>
        </div>
    </div>
</template>

<script>
import {
    mapGetters, mapActions
} from "vuex";
export default {
    data() {
        return {
            bgImage: require('../../../assets/images/thankuSecBg.svg'),
            SSOLogin: JSON.parse(localStorage.getItem('SSOLogin')) ?? null,
        };
    },
    computed: {
        ...mapGetters(["signOutResponse"])
    },
    watch: {

    signOutResponse: function (val) {
      if (val) {
        // Clean up body styles before logout (especially for mobile)
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.width = '';
        
        localStorage.removeItem('user')
        localStorage.removeItem('isSilentLogin')
        localStorage.removeItem('isProtectionPlans')
        localStorage.removeItem('is_from_mobile')
        localStorage.removeItem('SSOLogin')
        window.location.replace(this.SSOLogin.success + `&order_number=${this.$route.query.order_id}`)
        this.resetSate()
      }
    },
    },
    mounted() {
        document.documentElement.style.overflow = '';
    },
    beforeUnmount() {
        document.documentElement.style.overflow = '';
    },
    methods: {
        ...mapActions(["signOut", "resetSate"]),

        onContinueClicked() {
            if (this.SSOLogin) {
                this.signOut({})
            } else {
                this.$router.replace("/purchases")
            }

        }
    }
};
</script>